var map = {
	"./de/general6/slide2.svg": 610392,
	"./en/general6/slide2.svg": 651836,
	"./es/general6/slide2.svg": 355681,
	"./fr/general6/slide2.svg": 112377,
	"./nl/general6/slide2.svg": 25019,
	"./pt/general6/slide2.svg": 106477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24816;